// extracted by mini-css-extract-plugin
export default {"wrapper":"AccionaCollapsableCard_wrapper__FEshs","more":"AccionaCollapsableCard_more__MzFvB","visible":"AccionaCollapsableCard_visible__O0GD1"};